import { render, staticRenderFns } from "./NumberInput.vue?vue&type=template&id=3b254e9f&scoped=true&"
import script from "./NumberInput.vue?vue&type=script&lang=ts&"
export * from "./NumberInput.vue?vue&type=script&lang=ts&"
import style0 from "./NumberInput.vue?vue&type=style&index=0&id=3b254e9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b254e9f",
  null
  
)

export default component.exports